import { all, put, takeEvery } from "@redux-saga/core/effects";
import { setErrorStatus } from "../status/action";

export const actionTypes = {
  SET_TRACKS_DATA: "SET_TRACKS_DATA",
  PUT_TRACKING_LOADING: "PUT_TRACKING_LOADING",
  CLEAR_TRACKS_DATA: "CLEAR_TRACKS_DATA",
  LAST_UPDATED_AT: "LAST_UPDATED_AT"
};

function* getTracksWorker(action) {
  try {
    // yield setTracksLoading(true);

    yield put({
      type: "PUT_TRACKS_DATA",
      payload: action.payload.data
    });

    yield setTracksLoading(false);
  } catch (error) {
    yield setTracksLoading(false);
    setErrorStatus(error);
  }
}

function* clearTracksWorker() {
  yield put({
    type: "CLEAR_TRACKS"
  });
}

function* setTracksLoadingWorker(action) {
  yield put({
    type: "SET_TRACKER_LOADING",
    payload: {
      loading: action.payload.loading
    }
  });
}

function* lastUpdatedAtWorker() {
  yield put({
    type: "SET_LAST_UPDATED_AT",
    payload: +new Date()
  });
}

export default function* tracksWatcher() {
  yield all([
    takeEvery("PUT_TRACKING_LOADING", setTracksLoadingWorker),
    takeEvery("SET_TRACKS_DATA", getTracksWorker),
    takeEvery("CLEAR_TRACKS_DATA", clearTracksWorker),
    takeEvery("LAST_UPDATED_AT", lastUpdatedAtWorker)
  ]);
}

function* setTracksLoading(bool) {
  yield put({
    type: "SET_TRACKS_LOADING",
    payload: {
      loading: bool
    }
  });
}
